import { IQualification } from '@medely/types';

export const isI9Qualification = (qualification: IQualification | undefined): boolean => {
  return qualification?.slug === 'i_9_form';
};
